import styles from "./DifficultyInfoBox.module.css";

export interface DifficultyInfoBoxProps {
  description: string;
  /** Seconds per round/duel for the selected difficulty, or null for no time limit. */
  roundLimitSeconds: number | null;
  noLimitLabel: string;
}

/**
 * Shared "what does this difficulty actually change" box under the
 * difficulty segmented control on every game's start screen — a playful
 * card instead of a plain gray caption, with the timer called out as its
 * own badge (clock icon + seconds) rather than buried in prose.
 */
export function DifficultyInfoBox({ description, roundLimitSeconds, noLimitLabel }: DifficultyInfoBoxProps) {
  return (
    <div className={styles.box}>
      <p className={styles.description}>{description}</p>
      <p className={styles.timerBadge}>
        <ClockIcon />
        {roundLimitSeconds !== null ? `${roundLimitSeconds}s` : noLimitLabel}
      </p>
    </div>
  );
}

function ClockIcon() {
  return (
    <svg viewBox="0 0 20 20" width="14" height="14" aria-hidden focusable="false">
      <circle cx="10" cy="10" r="8" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M10 5.5 V10 L13.5 12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" fill="none" />
    </svg>
  );
}
